import { render, staticRenderFns } from "./ChallengesHome.vue?vue&type=template&id=47052764&"
import script from "./ChallengesHome.vue?vue&type=script&lang=js&"
export * from "./ChallengesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports